<template>
  <div class="container mb062">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>口座番号</HeadingOne>

    <NoticeBox v-if="errors.account_no" class="-error _mb-sm-40 _mb-md-60">
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody>
        <ul>
          <li>口座番号が誤っています。口座番号を再入力してください。</li>
        </ul>
      </NoticeBody>
    </NoticeBox>

    <ErrorsAlert v-else :errors="errors" class="_mt-md-60 _mt-sm-60"></ErrorsAlert>

    <HeadingTwo class="head-icon">
      口座番号認証
      <router-link
        :to="{ name: 'sv060', hash: '#section_03' }"
        target="_blank"
        @click="trackGtmEvent('【click】ステップ', 'ステップ③')"
      >
        <img src="@/assets/images/mb/common/question.svg" />
      </router-link>
    </HeadingTwo>

    <section>
      <ContactBox class="_mb-md-60 _mb-sm-20">
        <CardHeader class="_pb-md-0 _pb-sm-0">安全・安心にご利用いただくために </CardHeader>
        <CardBody>
          <ListGroup class="-normal _mb-md-0 _mb-sm-0">
            <ListItem class="-normal">
              第三者による不正な使用や情報変更を防ぐため、au PAY
              スマートローンではSMSを使用した追加認証を導入しております。<br />
              そのため、SMSが利用可能な携帯電話番号のご登録が必要となります。
            </ListItem>
            <ListItem class="-normal">
              携帯電話番号のご登録は、au PAY
              スマートローンでご登録いただいておりますお引落し口座番号による認証後に行います。
            </ListItem>
            <ListItem class="-normal _mb-md-0 _mb-sm-0">
              お借り入れなど、ご希望のお手続きは携帯電話番号ご登録完了後、再度操作をお願いいたします。
            </ListItem>
          </ListGroup>
        </CardBody>
      </ContactBox>
    </section>

    <p>お引落し口座番号７桁を入力してください。</p>
    <ListGroup class="-note">
      <ListItem class="-note"> 口座番号が0から始まる場合は、0から入力をしてください。 </ListItem>
      <ListItem class="-note">
        ご登録の銀行口座がゆうちょ銀行の場合は、
        <router-link
          :to="{ name: 'sv060', hash: '#section_03' }"
          target="_blank"
          class="-link"
          @click="trackGtmEvent('【click】ステップ', 'ステップ③')"
        >
          こちら
        </router-link>
        をご確認ください。
      </ListItem>
    </ListGroup>
    <section>
      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <TableRow>
              <TableHeader> 口座番号 </TableHeader>
              <TableData>
                <InputGroup>
                  <InputgroupAppend>
                    <InputItem id="account_no" v-model="inputCode.account_no" class="-md" :maxlength="7"></InputItem>
                  </InputgroupAppend>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <form novalidate @submit.prevent="submitBankAuth">
        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitBankAuth"> 認証する </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb001"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import { getUserDataLambdaInvoke, checkBankauthLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import { trackGtmEvent } from "@/utils/Gtm";

import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import ContactBox from "@/components/box/ContactBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "../components/card/CardBody";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputItem from "@/components/input/InputItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "Mb062",
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    ContactBox,
    CardHeader,
    CardBody,
    HeadingOne,
    HeadingTwo,
    BreadcrumbGroup,
    ErrorsAlert,
    InputGroup,
    InputgroupAppend,
    InputItem,
    ListGroup,
    ListItem,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
  },
  setup() {
    setMeta({
      title: "口座番号・口座番号認証",
      description: "",
      keywords: "",
    });

    return {
      trackGtmEvent,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "口座番号",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      userData: {
        user_session: "",
      },
      bankauthSend: {
        message: "",
        event: "",
      },
      inputCode: {
        account_no: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          if (!res.account_no) {
            this.$router.push({ name: "mb021" });
          };
          
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitBankAuth: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};

        initCredentials()
          .then(() => {
            checkBankauthLambdaInvoke(this.inputCode)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  if (this.errors["bank_auth"]?.includes("lock")) {
                    this.$router.push({ name: "mb063" });
                  } else {
                    scrollTop();
                    this.isDisabled = false;
                  }
                } else if (Object.keys(this.errors).length === 0) {
                  let resBody = JSON.parse(res.body);
                  for (let key in resBody) {
                    if (Object.prototype.hasOwnProperty.call(this.bankauthSend, key)) {
                      this.bankauthSend[key] = resBody[key];
                    }
                  }
                  this.$router.push({ name: "mb065" });
                } else {
                  this.$router.push({ name: "SessionTimeOut" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
.contact-box {
  > .card-body {
    justify-content: flex-start;
  }
}

.mb062 {
  .head-icon {
    :deep(.heading) {
      display: flex;
      align-items: center;
      justify-content: center;
      a {
        width: 24px;
        height: 24px;
        margin-left: 8px;
        @media screen and (max-width: 767px) {
          width: 18px;
          height: 18px;
        }
        img {
          width: 100%;
        }
      }
    }
  }

  :deep(.list-group) {
    &.-normal {
      > .list-item {
        &.-normal {
          list-style-type: disc;
        }
      }
    }
  }

  :deep(.contact-box) {
    border: 1px solid #cccccc;
    border-radius: 10px;
    margin: inherit;
  }

  .-link {
    text-decoration: underline;
  }
}
</style>
